import React from 'react';
import { Card, CardContent } from './ui/card';
import { Check } from 'lucide-react';

const ModelSelector = ({ models, selectedModel, onSelectModel }) => {
  return (
    <div className="space-y-4">
      <h2 className="text-2xl font-bold text-gray-900">Wählen Sie Ihr Modell</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {models.map((model) => (
          <Card
            key={model.id}
            className={`cursor-pointer transition-all duration-300 hover:shadow-lg hover:-translate-y-1 relative overflow-hidden ${
              selectedModel?.id === model.id
                ? 'ring-2 ring-emerald-500 shadow-lg'
                : 'hover:ring-1 hover:ring-gray-300'
            }`}
            onClick={() => onSelectModel(model)}
          >
            {selectedModel?.id === model.id && (
              <div className="absolute top-2 right-2 z-10 bg-emerald-500 rounded-full p-1">
                <Check className="w-4 h-4 text-white" />
              </div>
            )}
            <CardContent className="p-0">
              <div className="aspect-square bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center overflow-hidden">
                <img
                  src={model.image}
                  alt={model.name}
                  className="w-full h-full object-contain p-4 transition-transform duration-300 hover:scale-110"
                />
              </div>
              <div className="p-4">
                <h3 className="font-bold text-lg text-gray-900 text-center">{model.name}</h3>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default ModelSelector;